import React, { useEffect, useMemo, useRef, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import messages from './Messages';
import { EditorWrapper } from '../PDPTerms/style';
import HoverIcon from '../../../../components/HoverIcon';
import { connect, MapDispatchToProps } from 'react-redux';
import {
  addParticipants,
  autoGradeParticipants,
  createOrUpdateClass,
  createOrUpdateClassFn,
  queryClasses,
  queryClassesFn,
  sendMessagesToParticipant,
  updateParticipants,
} from 'store/pdp/pdpSlice';
import '../../../../basics/Object';
import { LoadingLine } from '../../TasksManagement/LoadingLine';
import APopover from '../../../../components/APopover';
import Button from '../../../../components/Button';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import { IOption } from '../../../../components/Select/Select';
import {
  black,
  blue,
  gray,
  green,
  lightGray,
  lightGreenSolid,
  red,
  white,
} from '../../../../utils/style/colors';
import notify from '../../../../components/Notify';
import { notifyError } from '../../../../components/Notify/Notify';
import Badge from '../../../../components/Badge';
import {
  isANumber,
  convertNumbersToProperFormat,
} from '../../../../utils/number';
import Icon from '../../../../components/Icon';
import CompanyMemberSelect from '../../../../components/FileManager/ItemsViewer/Survey/SurveyEditor/CompanyMemberSelect/CompanyMemberSelect';
import {
  CompanyPDPState,
  Participant,
  ParticipantPresence,
  ParticipantStatus,
  PDPClass,
} from '../../../../store/pdp/types';
import { appDispatch, IUsers } from '../../../../store/store';
import { ITags } from '../../../../store/providers/providerTypes';
import { ICompany } from '../../../../store/companies/companiesTypes';
import { IAnalyticsQuery } from '../../../../store/entity/IAnalyticsQuery';
import { IAnalyticResponse } from '../../../../store/entity/IAnalyticResponse';
import { requireSeveralUser } from '../../../../store/users/usersSlice';
import { getAnalyse } from '../../../../store/survey/surveySlice';
import { withTitle } from '../../../../components/withTitle';
import Dropdown from '../../../../components/Dropdown';
import LoadingCircleIndicator from '../../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import moment from 'moment-jalaali';
import { navigate } from '@reach/router';
import { removeDuplicates } from '../../../../utils/happyFunctions';
import ExportExcell from './ExportExcell';
import Modal from '../../../../components/Modal/Modal';
import CoursePhaseList from './CoursePhaseList';
import { CoursePhaseContainerAPopover } from './style';
import { MultiDatePicker } from '../../../../components/MyDatePicker/MultiDatePicker';
import Popover from '../../../../components/Popover/Popover';
import { smartDateDuration } from '../../../../utils/date';

interface IOwnProps {
  pdpID: number;
  clazz: PDPClass;
  users: IUsers;
  tags: ITags['data'];
  company: ICompany;
  pdpState: CompanyPDPState;
}

interface DispatchToProps {
  updateParticipants: (pdpId: number, participants: Participant[]) => any;
  sendMessageToParticipant: (
    message: string,
    clazzId: number,
    groups: string[]
  ) => Promise<any>;
  autoGradeParticipants: (
    pdpId: number,
    clazzId: number,
    groupId: string | null,
    participantId?: number
  ) => Promise<any>;
  addParticipants: (
    pdpId: number,
    clazzId: number,
    userIds: number[],
    isCorrective: boolean,
    group?: string,
    correctiveForClass?: number
  ) => any;
  getAnalyse: (
    dataQuery: IAnalyticsQuery,
    surveyToken?: string,
    ownerToken?: string,
    reportToken?: string
  ) => Promise<IAnalyticResponse>;
  requireSeveralUser: (usersList: number[]) => Promise<void>;

  queryClasses: (
    pdpId: number,
    startDate?: number,
    endDate?: number,
    topicId?: number
  ) => ReturnType<typeof queryClassesFn>;

  createOrUpdateClass: (
    clazz: PDPClass,
    pdpId: number
  ) => ReturnType<typeof createOrUpdateClassFn>;
}

type IComponentProps = DispatchToProps & IOwnProps;
type ClassGrads = {
  [userId: number]: { [phaseTagId: number | string]: number | undefined };
};

function getSortValue(participant: Participant) {
  switch (participant.participantProps.status) {
    case 'Attended':
      return 0;
    case 'Approved':
      return 1;
    case 'Rejected':
      return 2;
    case 'Dropped':
      return 3;
  }
}

function getStatusColor(status: ParticipantStatus) {
  switch (status) {
    case 'Attended':
      return blue;
    case 'Approved':
      return green;
    case 'Rejected':
      return red;
    case 'Dropped':
      return gray;
  }
}
const presenseOptions = ['Present', 'Absent'].map(
  (it) =>
    ({
      value: it,
      label: messages[it],
    }) as IOption
);
type TOTAL = 'total';
export const getEffectivity = (
  baseScore: number,
  currentScore: number,
  company: ICompany,
  pdpId: number
) => {
  const formula =
    company.pdpPanels.find((it) => it.id === pdpId)?.properties
      ?.effectivityFormula || 'Advanced';
  if (formula === 'Simple') return currentScore - baseScore;
  return 100 - baseScore!
    ? (100 * (currentScore - baseScore!)) / (100 - baseScore!)
    : 0;
};
const ClassMemberViewer: React.FC<IComponentProps> = ({
  clazz,
  pdpID,
  updateParticipants,
  users,
  getAnalyse,
  tags,
  company,
  pdpState,
  requireSeveralUser,
  sendMessageToParticipant,
  addParticipants,
  queryClasses,
  createOrUpdateClass,
  autoGradeParticipants,
}) => {
  const [openModalBaseonContribution, setOpenModalBaseonContribution] =
    useState<boolean>(false);
  const [declaredStatus, setDeclaredStatus] = useState<boolean>(false);
  const [loading, setLoading] = useState(new Set<string>());
  const loadingRef = useRef<Set<string>>();
  loadingRef.current = loading;
  const addLoading = (scope: string) => {
    const newLoading = cloneDeep(loadingRef.current);
    newLoading!.add(scope);
    setLoading(newLoading!);
    loadingRef.current = newLoading;
  };
  const [updateCustomTimeLoading, setUpdateCustomTimeLoading] =
    useState<boolean>(false);
  const [baseTagId, targetTagId] = useMemo(() => {
    let base = 0;
    let target = 0;
    Object.values(tags).forEach((it) => {
      if (it.text === 'پیش آزمون' || it.text === 'پیش‌آزمون') base = +it.id;
      if (it.text === 'پس آزمون' || it.text === 'پس‌آزمون') target = +it.id;
    });
    return [base, target];
  }, [tags]);
  const [memberGrades, setMemberGrades] = useState({} as ClassGrads);
  const [phaseWithGrade, setPhaseWithGrade] = useState(
    [] as (number | string)[]
  );

  const [selectedDistrict, setSelectedDistrict] = useState(
    null as number | null
  );
  const [selectedPost, setSelectedPost] = useState(null as number | null);

  const [userPhaseOverrides, setUserPhaseOverrides] = useState<{
    [userId: number]: Array<{
      phaseTagId: number;
      phaseStageId: number;
      startDate?: number;
      endDate?: number;
    }>;
  }>({});
  const [userCurrentStartDates, setUserCurrentStartDates] = useState<{
    [userId: number]: number;
  }>({});

  const allCurrentRoleIds = new Set<number>();
  Object.values(clazz.participants).forEach((it) => {
    if (it.userId) {
      Object.keys(company.members[it.userId]?.roles || {}).forEach((it) => {
        allCurrentRoleIds.add(Number(it));
      });
    }
  });

  useEffect(() => {
    setMemberGrades({});
    setPhaseWithGrade([]);
    const dataQuery: IAnalyticsQuery = {
      filters: [{ field: 'tags', type: 'termFilter', values: [-clazz.id] }],
      buckets: [
        {
          field: 'instance',
          type: 'bucket',
          name: 'users',
          includeTotal: true,
          subBuckets: [
            {
              field: 'tags',
              type: 'bucket',
              validBuckets: clazz.properties.phaseProps
                .filter((it) => !it.disabled)
                .map((it) => it.phaseTagId),
              name: 'courses',
            },
          ],
        },
      ],
      metrics: [
        { metric: 'percentageOfTotalAvg', field: 'score', name: 'score' },
      ],
    } as IAnalyticsQuery;
    addLoading('grades');
    let foundEffective = true;
    getAnalyse(dataQuery, undefined, undefined, clazz.reportToken)
      .then(({ result }: any) => {
        const classGrade: ClassGrads = {};
        const foundScoreForPhase = new Set<number>(
          company.pdpPanels
            .find((el) => el.id === pdpID)!
            .properties.classPhaseDefaultProps?.filter(
              (it) => it.phaseWithGrade
            )
            .map((it) => it.phaseTagId)
        );
        const users = result.categories?.['users'];
        if (users) {
          users.buckets.forEach((response: any) => {
            const userId: string | number = Number(response.val);
            if (!userId) return;
            classGrade[userId] = {};
            response.categories['courses'].buckets.forEach(
              (gradeBucket: any) => {
                const tagId = Number(gradeBucket.val);
                const score = gradeBucket.metrics['score'];
                classGrade[userId][tagId] = score;
                foundScoreForPhase.add(tagId);
              }
            );
            const baseScore = classGrade[userId][baseTagId];
            const currentScore = classGrade[userId][targetTagId];
            if (isANumber(baseScore) && isANumber(currentScore)) {
              classGrade[userId].effectivity = getEffectivity(
                baseScore!,
                currentScore!,
                company,
                pdpID
              );
              foundEffective = true;
            }
          });
        }
        setMemberGrades(classGrade);
        const withGradePhases: (number | string)[] = Array.from(
          foundScoreForPhase
        ).sort(
          (a, b) =>
            (tags[a]?.order || Number(tags[a]?.id)) -
            (tags[b]?.order || Number(tags[b]?.id))
        );
        if (foundEffective) withGradePhases.push('effectivity');
        setPhaseWithGrade(withGradePhases);
      })
      .finally(() => {
        removeLoading('grades');
      });
  }, [clazz.id]);

  function removeLoading(scope: string) {
    const newLoading = cloneDeep(loadingRef.current);
    newLoading!.delete(scope);
    setLoading(newLoading!);
    loadingRef.current = newLoading;
  }

  const [filterGroupKey, setFilterGroupKey] = useState(null as null | string);
  const [userAddGroup, setUserAddGroup] = useState(null as null | string);
  const rejectMember = (participant: Participant) => {
    if (confirm(messages.rejectMember(users[participant.userId]?.name || ''))) {
      const newParticipant = cloneDeep(participant);
      newParticipant.participantProps.status = 'Dropped';
      const scope = participant.userId + 'drop';
      addLoading(scope);
      updateParticipants(pdpID, [newParticipant]).finally(() => {
        removeLoading(scope);
      });
    }
  };
  const reAddMember = (participant: Participant) => {
    if (confirm(messages.reAddtMember(users[participant.userId]?.name || ''))) {
      const newParticipant = cloneDeep(participant);
      newParticipant.participantProps.status = 'Attended';
      addLoading(participant.userId + 'drop');
      updateParticipants(pdpID, [newParticipant]).finally(() => {
        removeLoading(participant.userId + 'drop');
      });
    }
  };

  const [message, setMessage] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);

  const [selectedToAddUser, setSelectedToAddUser] = useState([] as number[]);
  const [addingMembers, setAddingMembers] = useState(false);

  const addMembers = () => {
    setAddingMembers(true);
    const oldLenth = Object.keys(clazz.participants).length;
    addParticipants(
      pdpID,
      clazz.id,
      selectedToAddUser,
      clazz.properties.corrective || false,
      userAddGroup || undefined
    )
      .then(
        (c: any) => {
          notify(messages.membersAdded(c.participants.length - oldLenth));
          setSelectedToAddUser([]);
          setAddingMembers(false);
        },
        (e: any) => {
          notifyError(e);
        }
      )
      .finally(() => setAddingMembers(false));
  };
  const allowdRoles = new Set<number>();
  clazz?.relatedTermIds.forEach((it) => {
    pdpState?.terms?.[it]?.term?.properties?.targetRoleIds?.forEach((it) =>
      allowdRoles.add(it)
    );
  });
  const groupOptions = (clazz.properties.classGroups || []).map((g) => ({
    value: g.key,
    label: g.title,
  }));
  const [messageGroups, setMessageGroups] = useState([] as string[]);
  const [recalculateGroup, setRecalculateGroup] = useState(
    null as null | string
  );
  groupOptions.push({ value: '', label: messages.unknown });
  const sendMessage = () => {
    if (sendingMessage) return;
    setSendingMessage(true);
    sendMessageToParticipant(message, clazz.id, messageGroups)
      .then(
        (it: any) => {
          notify(messages.sentTo(it.result.message));
        },
        (e) => {
          notifyError(e.result);
        }
      )
      .finally(() => {
        setSendingMessage(false);
      });
  };

  const filterdParticipants = Object.values(clazz.participants)
    .filter((p) => {
      return (
        (!selectedPost || company.members[p.userId]?.roles?.[selectedPost]) &&
        (!selectedDistrict ||
          company.members[p.userId]?.roles?.[selectedDistrict]) &&
        (filterGroupKey === null ||
          (p.participantProps.group ?? '') === filterGroupKey)
      );
    })
    .sort((a, b) => getSortValue(a) - getSortValue(b));
  let activeMembers = 0;
  let presentMembers = 0;
  let approvedMembers = 0;
  let gradeSum = 0;
  let gradeCount = 0;
  const totals = {} as { [key: string | number]: number };
  const totalCounts = {} as { [key: string | number]: number };
  filterdParticipants.forEach((p) => {
    if (p.participantProps.status !== 'Dropped') {
      activeMembers++;
      if (p.participantProps.present === 'Present') presentMembers++;
      if (p.participantProps.status === 'Approved') approvedMembers++;
      if (isANumber(p.participantProps.grade)) {
        gradeSum += p.participantProps.grade!;
        gradeCount++;
      }
    }
  });

  const markRemainingAs = (present: boolean) => {
    const toSave = filterdParticipants
      .filter(
        (it) =>
          it.participantProps.present === null &&
          it.participantProps.status !== 'Dropped'
      )
      .map((p) => {
        const clone = cloneDeep(p);
        clone.participantProps.present = present ? 'Present' : 'Absent';
        return clone;
      });
    addLoading(`present_${present}`);
    updateParticipants(pdpID, toSave).finally(() => {
      removeLoading(`present_${present}`);
    });
  };

  const phaseOptions = clazz.properties.phaseProps
    .filter((item) => item.phaseWithGrade)
    .reduce((acc: IOption[], item) => {
      acc.push({
        label:
          Object.values(tags).find((el) => el.id === item.phaseTagId)?.text ||
          '',
        value: item.phaseTagId,
      });
      return acc;
    }, []);

  const groupOptionsWithAll = [
    { label: messages.all, value: 'all' },
    ...groupOptions,
  ];

  const [selectedPhaseOptions, setSelectedPhaseOptions] = useState<string>('');
  const [selectedGroupForStatus, setSelectedGroupForStatus] =
    useState<string>('all');

  const handleChangeGroupOptions = (values: IOption[]) => {
    setSelectedGroupForStatus(values[0].value.toString());
  };

  const handleChangeSelectedPhaseOptions = (values: IOption[]) => {
    setSelectedPhaseOptions(values[0].value.toString());
  };

  const handleChangeStatusBaseonFilters = () => {
    const filteredParticipantsBaseonChangeStatus = filterdParticipants
      .filter((item) => item.participantProps.status !== 'Dropped')
      .filter((item) =>
        selectedGroupForStatus !== 'all'
          ? item.participantProps.group === selectedGroupForStatus
          : true
      );
    let participants = null;
    if (declaredStatus) {
      participants = cloneDeep(
        filteredParticipantsBaseonChangeStatus.filter(
          (item) => item.participantProps.present === null
        )
      );
    } else {
      participants = cloneDeep(filteredParticipantsBaseonChangeStatus);
    }
    participants.map((user) => {
      user.participantProps.present = memberGrades?.[user.userId]?.[
        Number(selectedPhaseOptions)
      ]
        ? 'Present'
        : 'Absent';
    });
    if (participants?.length > 0) {
      addLoading('present_phase');
      updateParticipants(pdpID, participants)
        .then(() => {
          setOpenModalBaseonContribution(false);
        })
        .catch((e: any) => notifyError(e))
        .finally(() => {
          removeLoading('present_phase');
        });
    } else {
      setOpenModalBaseonContribution(false);
    }
  };

  const [fetchedCorrectiveOptions, setFetchedCorrectiveOptions] = useState(
    'notFetched' as 'notFetched' | 'fetched' | 'fetching' | 'failFetched'
  );
  const [creatingCorrectiveClass, setCreatingCorrectiveClass] = useState(
    null as number | null
  );
  useEffect(() => {
    setFetchedCorrectiveOptions('notFetched');
  }, [clazz.id]);
  const createCorrectiveClassOptions = [
    ...Object.values(pdpState.classes || {}).filter((c) => {
      return (
        c.topicId === clazz.topicId &&
        !c.template &&
        c.id !== clazz.id &&
        !c.deleted
      );
    }),
    {
      properties: {
        phaseProps:
          company.pdpPanels.find((el) => el.id === pdpID)!.properties
            .classPhaseDefaultProps || [],
        allowChooseGroup: 'AllowChange',
        classGroups: [],
        classDocumentHomeId: null as any,
        corrective: true,
        autoApproveProps: clazz.properties.autoApproveProps,
      },
      id: undefined as any,
      participants: [],
      relatedTermIds: clazz.relatedTermIds,
      topicId: clazz.topicId,
      template: true,
    } as PDPClass,
  ];
  function addAllUsersToClass(
    notInClass: number[],
    foundClass: PDPClass
  ): Promise<any> {
    return addParticipants(
      pdpID,
      foundClass.id,
      notInClass,
      true,
      undefined,
      clazz.id
    ).then(
      (pdpClass: any) => {
        const foundUsers = notInClass
          .filter((it) => pdpClass.participants[it])
          .map((it) => users[it].name)
          .join(messages.comma + ' ');
        notify(
          messages.usersAddedToCorrectiveClass(
            foundUsers,
            pdpState.topics![pdpClass.topicId].properties.name
          )
        );
      },
      (reason: any) => {
        notifyError(reason);
      }
    );
  }

  const getToAddUsers = (clazz: PDPClass) => {
    return Object.values(clazz.participants)
      .filter((it) => it.participantProps.status === 'Rejected')
      .map((it) => it.userId);
  };
  const [showCorrectivePop, setShowCorrectivePop] = useState(false);

  function createClass(foundClass: PDPClass) {
    setCreatingCorrectiveClass(0);
    const newClazz = cloneDeep(foundClass!) as PDPClass;
    newClazz.id = undefined as any;
    newClazz.startDate =
      pdpState.terms![clazz.relatedTermIds[0]]?.term?.startDate || Date.now();
    newClazz.endDate =
      pdpState.terms![clazz.relatedTermIds[0]]?.term?.endDate || Date.now();
    newClazz.template = false;
    const toAddUsers = getToAddUsers(clazz);
    createOrUpdateClass(newClazz, pdpID)
      .then(
        ({ classes }: { classes: PDPClass[] }) => {
          if (toAddUsers && toAddUsers.length)
            addAllUsersToClass(toAddUsers, classes[0]!).finally(() => {
              setShowCorrectivePop(false);
              navigate(`./${classes[0]!.id}#edit`);
            });
          else {
            setShowCorrectivePop(false);
            navigate(`./${classes[0]!.id}#edit`);
          }
        },
        (err) => {
          notifyError(err);
        }
      )
      .finally(() => {
        setCreatingCorrectiveClass(null);
      });
  }

  function addTermToClass(foundClass: PDPClass) {
    setCreatingCorrectiveClass(foundClass.id);
    const newClazz = cloneDeep(foundClass!) as PDPClass;
    newClazz.relatedTermIds.push(...clazz.relatedTermIds);
    newClazz.relatedTermIds = removeDuplicates(newClazz.relatedTermIds);
    createOrUpdateClass(newClazz, pdpID)
      .then(() => {
        const toAddUsers = getToAddUsers(clazz);
        if (toAddUsers && toAddUsers.length)
          addAllUsersToClass(toAddUsers, newClazz!).finally(() => {
            setShowCorrectivePop(false);
            navigate(`./${newClazz!.id}#edit`);
          });
        else {
          setShowCorrectivePop(false);

          navigate(`./${newClazz!.id}#edit`);
        }
      })
      .finally(() => {
        setCreatingCorrectiveClass(null);
      });
  }

  const handleGetParticipantsData = () => {
    const gradeHeaders = phaseWithGrade.reduce(
      (current, tagId: string | number) => {
        const title = tags[tagId]?.text ?? messages[tagId] ?? tagId;
        return { ...current, [title]: title };
      },
      {}
    );
    // define headers
    const data = [
      {
        participants: `${messages.participant} (${messages.persons(activeMembers)})`,
        employeeId: `${messages.employeeId}`,
        group: `${messages.group}`,
        ...gradeHeaders,
        presence: `${messages.presence}`,
        status: `${messages.status}`,
      },
    ];

    [...filterdParticipants, { userId: 'total' as TOTAL }].map(
      (participant) => {
        const groupName =
          clazz.properties.classGroups.find(
            (item) =>
              item.key === (participant as Participant).participantProps?.group
          )?.title || (participant.userId === 'total' ? '-' : messages.unknown);
        const phaseGrade = phaseWithGrade.reduce((acc, tagId) => {
          const phaseGradeTitle = tags[tagId]?.text ?? messages[tagId] ?? tagId;
          if (participant.userId !== 'total') {
            const grade: any = memberGrades?.[participant.userId]?.[tagId];
            if (isANumber(grade)) {
              totals[tagId] = (totals[tagId] || 0) + grade!;
              totalCounts[tagId] = (totalCounts[tagId] || 0) + 1;
            }
            return {
              ...acc,
              [phaseGradeTitle]: isANumber(grade)
                ? grade?.toFixed(0) + messages.percentEn
                : '---',
            };
          } else {
            const totalCount = totalCounts[tagId];
            const total = totals[tagId];
            return {
              ...acc,
              [phaseGradeTitle]:
                totalCount > 0
                  ? (total / totalCount).toFixed(0) + messages.percentEn
                  : '---',
            };
          }
        }, {});
        const presence =
          participant.userId !== 'total'
            ? messages?.[
                presenseOptions.find(
                  (it) =>
                    it.value ===
                    (participant as Participant).participantProps?.present
                )?.value as string
              ] || messages.unknown
            : `${((activeMembers ? presentMembers / activeMembers : 0) * 100).toFixed(0)} ${messages.percentEn} (${messages.personsEn(presentMembers)})`;
        const status =
          participant.userId !== 'total'
            ? messages[participant.participantProps.status]
            : `${((activeMembers ? approvedMembers / activeMembers : 0) * 100).toFixed(0)} ${messages.percentEn} (${messages.personsEn(approvedMembers)})`;
        data.push({
          participants:
            participant.userId === 'total'
              ? `${messages.average}`
              : `${users[participant.userId]?.name}`,
          employeeId: `${company.members[participant.userId]?.employeeId || ''}`,
          group: `${groupName}`,
          ...phaseGrade,
          presence: presence,
          status: status,
        });
      }
    );

    return data;
  };

  const getCurrentCourseStartDate = (
    groupId: string,
    participant: Participant,
    currentOverrides?: Array<{
      phaseTagId: number;
      phaseStageId: number;
      startDate?: number;
      endDate?: number;
    }>
  ) => {
    const overridesToUse =
      currentOverrides ||
      participant?.participantProps?.phasePropOverride ||
      [];

    const allCurrentPhaseDates = clazz.properties.phaseProps
      .filter((phase) => !phase.disabled)
      .map((phase) => {
        const override = overridesToUse.find(
          (o) =>
            o.phaseTagId === phase.phaseTagId &&
            o.phaseStageId === phase.phaseStageId
        );
        return override?.startDate ?? phase.phaseStartDates?.[groupId];
      })
      .filter((date) => date !== null);

    return allCurrentPhaseDates.length > 0
      ? Math.min(...allCurrentPhaseDates)
      : 0;
  };

  const handleChangePhase = (
    userId: number,
    overrides: Array<{
      phaseTagId: number;
      phaseStageId: number;
      startDate?: number;
      endDate?: number;
    }>
  ) => {
    setUserPhaseOverrides((prev) => ({
      ...prev,
      [userId]: overrides,
    }));
  };

  const handleResetCustomTime = (userId: number) => {
    const result = confirm(messages.willBeReset);
    if (result) {
      const participant = clazz.participants[userId];
      const groupId = participant?.participantProps?.group;

      setUserPhaseOverrides((prev) => ({
        ...prev,
        [userId]: [],
      }));

      if (groupId) {
        const newStartDate = getCurrentCourseStartDate(
          groupId,
          participant,
          []
        );
        setUserCurrentStartDates((prev) => ({
          ...prev,
          [userId]: newStartDate,
        }));
      }
    }
  };

  const handleSaveCustomTime = async (userId: number) => {
    setUpdateCustomTimeLoading(true);
    const updatedParticipant = cloneDeep(clazz.participants[userId]);
    updatedParticipant.participantProps.phasePropOverride =
      userPhaseOverrides[userId] || [];
    try {
      await updateParticipants(pdpID, [updatedParticipant]);
    } finally {
      setUpdateCustomTimeLoading(false);
    }
  };

  const recalculationDisabled =
    !isANumber(clazz.properties.autoApproveProps.approvePercent) ||
    !clazz.properties.autoApproveProps.phaseList?.length;
  return (
    <EditorWrapper
      style={{
        flexGrow: '1',
        height: '100%',
        marginRight: 0,
        border: `3px solid ${lightGreenSolid}`,
      }}
    >
      {openModalBaseonContribution && (
        <Modal
          width="300px"
          height="50%"
          title={messages.markAllUsersWithContribution}
          onClose={() => setOpenModalBaseonContribution(false)}
          isActive={openModalBaseonContribution}
        >
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-3">
              <Select
                label={messages.targetGroup}
                key="group-options"
                options={groupOptionsWithAll}
                values={groupOptionsWithAll.filter(
                  (item) => item.value.toString() === selectedGroupForStatus
                )}
                onChangeValues={handleChangeGroupOptions}
              />
              <Select
                label={messages.submitBaseonContribution}
                key="group-options"
                options={phaseOptions}
                values={phaseOptions.filter(
                  (item) => item.value.toString() === selectedPhaseOptions
                )}
                onChangeValues={handleChangeSelectedPhaseOptions}
              />

              <Input
                id={'declareStatus'}
                checked={declaredStatus}
                label={messages.markThoseWithDeclaredStatus}
                onChange={(e) => setDeclaredStatus(e.target.checked)}
                type={'checkbox'}
              />
            </div>
            <div className="flex justify-end">
              <Button
                onClick={handleChangeStatusBaseonFilters}
                color="black-outline"
                loading={loading.has('present_phase')}
              >
                {messages.confirmChanges}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {loading.has('grades') && <LoadingLine />}
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: '10px',
            alignItems: 'center',
          }}
          className={'hide-on-mobile'}
        >
          <div
            className={'hide-on-mobile'}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <span>{messages.filter}:</span>
            <Select
              values={
                selectedDistrict
                  ? [
                      {
                        value: selectedDistrict,
                        label: company.roles[selectedDistrict].name,
                      },
                    ]
                  : []
              }
              options={Object.values(company.roles)
                .filter(
                  (it) =>
                    it.roleType === 'District' && allCurrentRoleIds.has(it.id)
                )
                .map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
              placeholder={messages.filterDistrict}
              onChangeValues={(it) => {
                setSelectedDistrict(it.length ? Number(it[0]?.value) : null);
              }}
            />
            <Select
              values={
                selectedPost
                  ? [
                      {
                        value: selectedPost,
                        label: company.roles[selectedPost].name,
                      },
                    ]
                  : []
              }
              options={Object.values(company.roles)
                .filter(
                  (it) =>
                    (it.roleType === 'Post' || it.roleType === null) &&
                    allCurrentRoleIds.has(it.id)
                )
                .map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
              placeholder={messages.filterPost}
              onChangeValues={(it) => {
                setSelectedPost(it.length ? Number(it[0]?.value) : null);
              }}
            />
          </div>
          <div style={{ flex: 1 }}></div>
          <ExportExcell
            getData={handleGetParticipantsData}
            exportFileName={messages.classOutput(
              pdpState.topics?.[clazz.topicId]?.properties.name || '',
              clazz.properties.corrective,
              clazz.startDate,
              clazz.relatedTermIds
                .map((tid) => pdpState.terms?.[tid].term?.properties?.name)
                .join(', ')
            )}
            hasResult={true}
            body={
              <Button>
                <Icon type={'download'} />
              </Button>
            }
          />
          <APopover
            target={
              <div>
                {withTitle(
                  <Button>
                    <Icon color={blue} type="repeat" titlePlacement={'top'} />
                  </Button>,
                  messages.createCorrectiveClass
                )}
              </div>
            }
            show={showCorrectivePop}
            onShowChange={(e) => {
              setShowCorrectivePop(e);
              if (fetchedCorrectiveOptions === 'notFetched') {
                queryClasses(
                  pdpID,
                  moment(clazz.startDate).startOf('jYear').valueOf(),
                  moment(clazz.startDate).endOf('jYear').valueOf(),
                  clazz.topicId
                ).then(
                  () => {
                    setFetchedCorrectiveOptions('fetched');
                  },
                  () => {
                    setFetchedCorrectiveOptions('failFetched');
                  }
                );
              }
            }}
            placement="bottom"
            curveBorder
            trigger="click"
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                background: white,
                padding: '1rem',
              }}
            >
              {isANumber(creatingCorrectiveClass) ||
              fetchedCorrectiveOptions !== 'fetched' ? (
                <LoadingCircleIndicator />
              ) : (
                <>
                  <h5>{messages.createCorrectiveClass}</h5>
                  <div>{messages.correectiveClassHint}</div>
                  <Dropdown.Menu
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    {createCorrectiveClassOptions.map((it, idx: number) => {
                      if (!it.id) {
                        return (
                          <Dropdown.MenuItem
                            key={idx}
                            // color="green-outline"
                          >
                            <span onClick={() => createClass(it)}>
                              <Icon type="plus" />{' '}
                              {messages.createNewCorrectiveClass(
                                pdpState.topics?.[it.topicId]?.properties
                                  ?.name || ''
                              )}
                            </span>
                          </Dropdown.MenuItem>
                        );
                      } else {
                        return (
                          <Dropdown.MenuItem
                            key={idx}
                            // color="blue-outline"
                          >
                            <span onClick={() => addTermToClass(it)}>
                              <Icon type="link-2" />{' '}
                              {messages.useClassSharedWith(
                                it.properties.corrective === true,
                                it.relatedTermIds.map(
                                  (it) =>
                                    pdpState.terms![it].term?.properties
                                      ?.name || ''
                                ),
                                it.id
                              )}
                              <HoverIcon
                                type={'eye'}
                                color="blue"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigate(
                                    `/t/${company.id}/pdp/${pdpID}/terms/${it.relatedTermIds[0]}/class/${it.id}`
                                  );
                                }}
                                title={
                                  <table>
                                    <tbody>
                                      <tr>
                                        <th>{messages.period}</th>
                                        <td>
                                          {smartDateDuration(
                                            it.startDate,
                                            it.endDate
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>{messages.participant}</th>
                                        <td>
                                          {messages.persons(
                                            Object.values(
                                              it.participants
                                            ).filter(
                                              (p) =>
                                                p.participantProps.status !==
                                                'Dropped'
                                            ).length
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                }
                              />
                            </span>
                          </Dropdown.MenuItem>
                        );
                      }
                    })}
                  </Dropdown.Menu>
                </>
              )}{' '}
            </div>
          </APopover>
          <APopover
            target={
              <span>
                {withTitle(
                  <Button>
                    <Icon
                      color={blue}
                      type="user-plus"
                      titlePlacement={'top'}
                    />
                  </Button>,
                  messages.addMembers
                )}
              </span>
            }
            arrow
            placement="top"
            curveBorder
            trigger="click"
          >
            <div
              style={{
                maxWidth: '30rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: '10px',
              }}
            >
              <div className="flex justify-between w-full">
                {clazz.properties.classGroups?.length > 1 && (
                  <th>
                    <Select
                      multiChoice={false}
                      allowRemove={true}
                      placeholder={messages.group}
                      onChangeValues={(v) => {
                        if (!v.length) setUserAddGroup(null);
                        else setUserAddGroup(v[0].value.toString());
                      }}
                      options={groupOptions}
                      values={groupOptions.filter(
                        (it) => it.value === userAddGroup
                      )}
                    />
                  </th>
                )}
                <Button
                  style={{ marginTop: '10px' }}
                  disabled={selectedToAddUser.length === 0}
                  loading={addingMembers}
                  onClick={addMembers}
                >
                  {messages.addMembers}
                </Button>
              </div>
              <span
                style={{ flexGrow: 1, maxWidth: '25rem', maxHeight: '70vh' }}
              >
                <CompanyMemberSelect
                  maxWidth="23rem"
                  usePop={false}
                  companyMembers={company.members as any}
                  roleIds={Array.from(allowdRoles)}
                  onSelectUser={(list: number[]) => {
                    if (
                      list.filter(
                        (it) =>
                          clazz.participants[it] &&
                          clazz.participants[it].participantProps.status !==
                            'Dropped'
                      ).length > 0
                    ) {
                      notify(messages.userIsAlreadyAMember, 'warning');
                    }
                    setSelectedToAddUser(
                      list.filter(
                        (it) =>
                          !clazz.participants[it] ||
                          clazz.participants[it].participantProps.status ===
                            'Dropped'
                      )
                    );
                  }}
                  label={messages.selectUsersToAdd}
                  placeholder={''}
                  selected={selectedToAddUser}
                  requireSeveralUser={requireSeveralUser}
                  multiSelect
                  showRoles
                  company={company}
                />
              </span>
            </div>
          </APopover>
          <APopover
            target={
              <span>
                {withTitle(
                  <Button>
                    <Icon color={red} type="check" titlePlacement={'top'} />
                  </Button>,
                  messages.recalculateApproveState
                )}
              </span>
            }
            arrow
            placement="top"
            curveBorder
            trigger="click"
          >
            <div>
              <p
                style={{
                  color: recalculationDisabled ? red : black,
                  margin: '1rem',
                }}
              >
                {recalculationDisabled
                  ? messages.recalculationDisabled
                  : messages.confirmRecalculateApproveState(
                      clazz.properties.autoApproveProps.approvePercent!
                    )}
              </p>
              {clazz.properties.classGroups.length > 1 && (
                <Select
                  multiChoice={false}
                  allowRemove={true}
                  placeholder={recalculateGroup ? '' : messages.allParticipents}
                  onChangeValues={(v) => {
                    if (!v.length) setRecalculateGroup(null);
                    else setRecalculateGroup(v[0]?.value?.toString());
                  }}
                  label={messages.targetGroup}
                  options={groupOptions}
                  values={groupOptions.filter(
                    (it) => recalculateGroup === it.value
                  )}
                />
              )}
              <Button
                style={{ marginTop: '1rem' }}
                loading={loading.has('recalculateApproveState')}
                onClick={() => {
                  addLoading('recalculateApproveState');
                  autoGradeParticipants(
                    pdpID,
                    clazz.id,
                    recalculateGroup,
                    undefined
                  )
                    .then(() => {
                      notify(messages.reacalculationDone);
                    })
                    .finally(() => {
                      removeLoading('recalculateApproveState');
                    });
                }}
                disabled={recalculationDisabled}
                color={'blue'}
              >
                {messages.recalculateApproveState}
              </Button>
            </div>
          </APopover>
          <APopover
            target={
              <span>
                {withTitle(
                  <Button>
                    <Icon
                      color={blue}
                      type="message-square"
                      titlePlacement={'top'}
                    />
                  </Button>,
                  messages.sendMessageToParticipants
                )}
              </span>
            }
            arrow
            placement="top"
            curveBorder
            trigger="click"
          >
            <div>
              {clazz.properties.classGroups.length > 1 && (
                <Select
                  multiChoice={true}
                  allowRemove={true}
                  placeholder={
                    messageGroups.length ? '' : messages.allParticipents
                  }
                  onChangeValues={(v) => {
                    setMessageGroups(v.map((it) => it.value.toString()));
                  }}
                  label={messages.targetGroup}
                  options={groupOptions}
                  values={groupOptions.filter((it) =>
                    messageGroups.includes(it.value)
                  )}
                />
              )}
              <Input
                id="message"
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                label={messages.messageToUsers}
              />
              <p>{messages.messageHint}</p>
              <Button loading={sendingMessage} onClick={sendMessage}>
                <Icon type={'send'} color={blue} />
                {messages.sendMessage}
              </Button>
            </div>
          </APopover>
        </div>
      </div>
      <div style={{ overflow: 'scroll', height: '100%' }}>
        <table style={{ flex: 1, borderCollapse: 'collapse' }}>
          <thead
            style={{
              position: 'sticky',
              top: '0',
              background: 'var(--exact-white)',
              boxShadow: ' inset 0 -1px 0 #CCC',
              zIndex: 1000,
            }}
          >
            <th>
              {messages.participant} ({messages.persons(activeMembers)})
            </th>
            {clazz.properties.classGroups?.length > 1 && (
              <th>
                <Select
                  multiChoice={false}
                  allowRemove={true}
                  placeholder={messages.group}
                  onChangeValues={(v) => {
                    if (!v.length) setFilterGroupKey(null);
                    else setFilterGroupKey(v[0].value.toString());
                  }}
                  options={groupOptions}
                  values={groupOptions.filter(
                    (it) => it.value === filterGroupKey
                  )}
                />
              </th>
            )}
            {phaseWithGrade.map((tagId) => (
              <th key={tagId}>
                {tags[tagId]?.text ?? messages[tagId] ?? tagId}
              </th>
            ))}

            <th>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>{messages.presence}</span>
                <Dropdown
                  curveBorder={true}
                  marginToTarget={4}
                  width={null}
                  target={
                    <div>
                      <Icon type={'more-vertical'} />
                    </div>
                  }
                >
                  <Dropdown.Menu>
                    <Dropdown.MenuItem>
                      <span
                        style={{ display: 'flex', gap: '10px' }}
                        onClick={() => {
                          markRemainingAs(true);
                        }}
                      >
                        <Icon
                          type={'check'}
                          color={green}
                          style={{}}
                          loading={loading.has('present_true')}
                        />
                        {messages.markAllRemainingAsPresent}
                      </span>
                    </Dropdown.MenuItem>
                    <Dropdown.MenuItem>
                      <span
                        style={{ display: 'flex', gap: '10px' }}
                        onClick={() => {
                          markRemainingAs(false);
                        }}
                      >
                        <Icon
                          type={'x'}
                          color={red}
                          loading={loading.has('present_false')}
                        />
                        {messages.markAllRemainingAsAbsent}
                      </span>
                    </Dropdown.MenuItem>
                    <Dropdown.MenuItem>
                      <span
                        style={{ display: 'flex', gap: '10px' }}
                        onClick={() => {
                          setOpenModalBaseonContribution(true);
                        }}
                      >
                        <Icon type={'check'} color={green} style={{}} />
                        {messages.markAllUsersWithContribution}
                      </span>
                    </Dropdown.MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </th>
            <th>{messages.status}</th>
            <th>{messages.actions}</th>
          </thead>
          <tbody>
            {[...filterdParticipants, { userId: 'total' as TOTAL }].map(
              (participant) => {
                const groupId = (participant as Participant)?.participantProps
                  ?.group;
                const userId = participant.userId;

                const phasePropOverride = userPhaseOverrides?.[
                  participant.userId
                ]
                  ? userPhaseOverrides?.[participant.userId]
                  : clazz.participants[participant.userId]?.participantProps
                      ?.phasePropOverride;

                const currentCourseStartDate =
                  userCurrentStartDates[userId] ||
                  (groupId
                    ? getCurrentCourseStartDate(
                        groupId,
                        participant as Participant,
                        phasePropOverride
                      )
                    : 0);

                return (
                  <tr
                    key={participant.userId}
                    className="hover-area"
                    style={{
                      color:
                        participant.userId !== 'total' &&
                        participant.participantProps.status === 'Dropped'
                          ? lightGray
                          : black,

                      ...(participant.userId === 'total' && {
                        boxShadow: ' inset 0 1px 0 #CCC',
                        position: 'sticky',
                        bottom: 0,
                        background: 'var(--exact-white)',
                      }),
                    }}
                  >
                    <td>
                      {participant.userId === 'total' ? (
                        messages.average
                      ) : (
                        <div className="flex flex-col">
                          <div>
                            <b>{users[participant.userId]?.name}</b>
                          </div>
                          <div className="text-sm mx-3">
                            {company.members[participant.userId]?.employeeId}
                          </div>
                        </div>
                      )}
                    </td>
                    {clazz.properties.classGroups?.length > 1 && (
                      <td>
                        {participant.userId !== 'total' ? (
                          <Select
                            multiChoice={false}
                            allowRemove={true}
                            placeholder={messages.unknown}
                            disabled={
                              participant.participantProps.status ===
                                'Dropped' ||
                              loading.has('group' + participant.userId)
                            }
                            onChangeValues={(v) => {
                              addLoading('group' + participant.userId);
                              const newPart = cloneDeep(
                                participant as Participant
                              );
                              newPart.participantProps.group =
                                v[0]?.value?.toString();
                              updateParticipants(pdpID, [newPart]).finally(
                                () => {
                                  removeLoading('group' + participant.userId);
                                }
                              );
                            }}
                            options={clazz.properties.classGroups.map((g) => ({
                              value: g.key,
                              label: g.title,
                            }))}
                            values={clazz.properties.classGroups
                              .map((g) => ({ value: g.key, label: g.title }))
                              .filter(
                                (it) =>
                                  it.value ===
                                  (participant as Participant).participantProps
                                    .group
                              )}
                          />
                        ) : (
                          <span></span>
                        )}
                      </td>
                    )}
                    {phaseWithGrade.map((tagId) => {
                      if (participant.userId !== 'total') {
                        const grade =
                          memberGrades?.[participant.userId]?.[tagId];
                        if (isANumber(grade)) {
                          totals[tagId] = (totals[tagId] || 0) + grade!;
                          totalCounts[tagId] = (totalCounts[tagId] || 0) + 1;
                        }
                        return (
                          <th key={tagId}>
                            {isANumber(grade)
                              ? convertNumbersToProperFormat(grade!, 1) +
                                messages.percent
                              : '---'}
                          </th>
                        );
                      } else {
                        const totalCount = totalCounts[tagId];
                        const total = totals[tagId];
                        return (
                          <th key={tagId}>
                            {totalCount > 0
                              ? convertNumbersToProperFormat(
                                  total / totalCount,
                                  1
                                ) + messages.percent
                              : '---'}
                          </th>
                        );
                      }
                    })}
                    <td>
                      {participant.userId !== 'total' ? (
                        <Select
                          multiChoice={false}
                          allowRemove={true}
                          placeholder={messages.unknown}
                          disabled={
                            participant.participantProps.status === 'Dropped' ||
                            loading.has('presence' + participant.userId)
                          }
                          onChangeValues={(v) => {
                            addLoading('presence' + participant.userId);
                            const newPart = cloneDeep(
                              participant as Participant
                            );
                            newPart.participantProps.present =
                              (v[0]?.value?.toString() as ParticipantPresence) ||
                              null;
                            updateParticipants(pdpID, [newPart]).finally(() => {
                              removeLoading('presence' + participant.userId);
                            });
                          }}
                          options={presenseOptions}
                          values={presenseOptions.filter(
                            (it) =>
                              it.value ===
                              (participant as Participant).participantProps
                                .present
                          )}
                        />
                      ) : (
                        <span>
                          {convertNumbersToProperFormat(
                            (activeMembers
                              ? presentMembers / activeMembers
                              : 0) * 100,
                            1
                          )}
                          {messages.percent} ({messages.persons(presentMembers)}
                          )
                        </span>
                      )}
                    </td>
                    <td>
                      {participant.userId !== 'total' ? (
                        <Badge
                          color={getStatusColor(
                            participant.participantProps.status
                          )}
                        >
                          {messages[participant.participantProps.status]}{' '}
                          {isANumber(participant.participantProps.grade)
                            ? '(' +
                              convertNumbersToProperFormat(
                                participant.participantProps.grade!,
                                0
                              ) +
                              messages.percent +
                              ')'
                            : ''}
                        </Badge>
                      ) : (
                        <span>
                          {convertNumbersToProperFormat(
                            (activeMembers
                              ? approvedMembers / activeMembers
                              : 0) * 100,
                            1
                          )}
                          {messages.percent} (
                          {messages.persons(approvedMembers)})
                          {!!gradeCount && (
                            <>
                              <br />
                              {messages.averageGrade}
                              {convertNumbersToProperFormat(
                                gradeCount ? gradeSum / gradeCount : 0,
                                1
                              )}
                              {messages.percent}
                            </>
                          )}
                        </span>
                      )}
                    </td>
                    <td
                      style={{
                        height: '45px',
                        width: '90px',
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ minWidth: '20px' }}>
                        {participant.userId !== 'total' &&
                          participant.correctiveClassId && (
                            <HoverIcon
                              color={'blue'}
                              type="repeat"
                              title={messages.correctiveClass}
                              onClick={() =>
                                navigate(`./${participant.correctiveClassId}`)
                              }
                            />
                          )}
                      </div>
                      <div style={{ minWidth: '20px' }}>
                        {participant.userId !== 'total' && (
                          <div className={'visible-on-hover'}>
                            {participant.participantProps.status !==
                              'Dropped' && (
                              <HoverIcon
                                color={'red'}
                                type="trash"
                                title={messages.delete}
                                loading={loading.has(
                                  participant.userId + 'drop'
                                )}
                                onClick={() => rejectMember(participant)}
                              />
                            )}
                            {participant.participantProps.status ===
                              'Dropped' && (
                              <HoverIcon
                                color={'red'}
                                type="rotate-ccw"
                                title={messages.reAdd}
                                loading={loading.has(
                                  participant.userId + 'drop'
                                )}
                                onClick={() => reAddMember(participant)}
                              />
                            )}
                          </div>
                        )}
                      </div>
                      {groupId && participant.userId !== 'total' && (
                        <Popover
                          trigger="click"
                          overlay={
                            <CoursePhaseContainerAPopover>
                              <div
                                style={{
                                  width: '100%',
                                  fontWeight: 'bold',
                                  padding: '0.5rem 0',
                                  fontSize: '1.25rem',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <div>
                                  {messages.customTimeTitleFor}{' '}
                                  {users?.[participant?.userId]?.name}
                                </div>
                              </div>
                              <div className="flex justify-end gap-2">
                                <Button
                                  onClick={() =>
                                    handleResetCustomTime(participant.userId)
                                  }
                                  color="black-outline"
                                >
                                  <Icon type={'rotate-cw'} />
                                  <div className="mx-1">
                                    {messages.resetCustomTime}
                                  </div>
                                </Button>
                                <Button
                                  onClick={() =>
                                    handleSaveCustomTime(participant.userId)
                                  }
                                  color="green"
                                  loading={updateCustomTimeLoading}
                                >
                                  {messages.save}
                                </Button>
                              </div>
                              <div
                                style={{
                                  width: '100%',
                                }}
                              >
                                <MultiDatePicker
                                  label={messages.courseBaseTime}
                                  className=""
                                  setDate={(value) => {
                                    const newTime = Number(value);
                                    setUserCurrentStartDates((prev) => ({
                                      ...prev,
                                      [participant.userId]: newTime,
                                    }));

                                    const gapTime =
                                      newTime - currentCourseStartDate;
                                    const updatedOverrides =
                                      clazz.properties.phaseProps
                                        .filter((phase) => !phase.disabled)
                                        .map((phase) => {
                                          const existingOverride =
                                            phasePropOverride?.find(
                                              (o: any) =>
                                                o.phaseTagId ===
                                                  phase.phaseTagId &&
                                                o.phaseStageId ===
                                                  phase.phaseStageId
                                            );

                                          const currentStartDate =
                                            existingOverride?.startDate ??
                                            phase.phaseStartDates?.[groupId];
                                          const currentEndDate =
                                            existingOverride?.endDate ??
                                            phase.phaseEndDates?.[groupId];

                                          return {
                                            phaseTagId: phase.phaseTagId,
                                            phaseStageId: phase.phaseStageId,
                                            startDate: currentStartDate
                                              ? currentStartDate + gapTime
                                              : undefined,
                                            endDate: currentEndDate
                                              ? currentEndDate + gapTime
                                              : undefined,
                                          };
                                        });

                                    setUserPhaseOverrides((prev) => ({
                                      ...prev,
                                      [participant.userId]: updatedOverrides,
                                    }));
                                  }}
                                  value={currentCourseStartDate}
                                  hasTime={true}
                                />
                              </div>
                              <CoursePhaseList
                                classPhaseProps={clazz.properties.phaseProps}
                                groupId={groupId}
                                tags={tags}
                                phasePropOverride={phasePropOverride}
                                defaultOpen={true}
                                onPhaseChange={(overrides) => {
                                  const newStartTime =
                                    getCurrentCourseStartDate(
                                      groupId,
                                      participant as Participant,
                                      overrides
                                    );

                                  setUserCurrentStartDates((prev) => ({
                                    ...prev,
                                    [participant.userId]: newStartTime,
                                  }));

                                  handleChangePhase(
                                    participant.userId,
                                    overrides
                                  );
                                }}
                              />
                            </CoursePhaseContainerAPopover>
                          }
                        >
                          <div
                            className={`${phasePropOverride?.length ? '' : 'visible-on-hover'}`}
                          >
                            <HoverIcon
                              title={messages.customTimeTitle}
                              type={'clock'}
                              color={blue}
                            />
                          </div>
                        </Popover>
                      )}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
    </EditorWrapper>
  );
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    updateParticipants: (pdpId: number, participants: Participant[]) =>
      appDispatch(updateParticipants({ pdpId, participants })),
    sendMessageToParticipant: (
      message: string,
      clazzId: number,
      groups: string[]
    ) => appDispatch(sendMessagesToParticipant({ message, clazzId, groups })),
    autoGradeParticipants: (
      pdpId: number,
      clazzId: number,
      group: string | null,
      participant?: number
    ) =>
      appDispatch(
        autoGradeParticipants({ pdpId, clazzId, group, participant })
      ),
    addParticipants: (
      pdpId: number,
      clazzId: number,
      userIds: number[],
      corrective: boolean,
      group?: string,
      correctiveForClass?: number
    ) =>
      appDispatch(
        addParticipants({
          pdpId,
          clazzId,
          userIds,
          group,
          isCorrective: corrective,
          correctiveForClass,
        })
      ),
    getAnalyse: (
      dataQuery: IAnalyticsQuery,
      surveyToken?: string,
      ownerToken?: string,
      reportToken?: string
    ) => {
      return appDispatch(
        getAnalyse({ dataQuery, surveyToken, ownerToken, reportToken })
      );
    },
    queryClasses: (
      pdpId: number,
      startDate?: number,
      endDate?: number,
      topicId?: number
    ) =>
      appDispatch(
        queryClasses({
          pdpId,
          topicId,
          endDate,
          startDate,
          isTemplate: false,
        })
      ),
    createOrUpdateClass: (pdpClass: PDPClass, pdpId: number) =>
      appDispatch(createOrUpdateClass({ clazz: pdpClass, pdpId })),
    requireSeveralUser: (usersList: number[]) =>
      appDispatch(requireSeveralUser({ usersList })),
  };
};

export default connect(null, mapDispatchToProps)(ClassMemberViewer);
